import { AppBarProps, Toolbar, Hidden, Box } from '@mui/material'
import { Menu } from '@mui/icons-material'
import { paths } from 'config'
import {
  StyledTopbar,
  IconButton,
  ButtonWrapper,
  Logo,
  Link,
} from './Topbar.style'
import LanguageSelect from './LanguageSelect'
import UserMenu from './UserMenu'
import { useCurrentUserCacheOnly } from 'shared/data'

export interface TopbarProps extends Partial<AppBarProps> {
  hidden?: boolean
  onMenuClick?: () => void
}

const Topbar = ({ hidden, onMenuClick, ...props }: TopbarProps) => {
  const { data: user } = useCurrentUserCacheOnly()

  if (hidden) return null

  const isAdmin = user?.viewer.isAdmin
  const logoTarget = isAdmin ? paths.home : paths.parkingSpots

  return (
    <StyledTopbar position="sticky" color="primary" {...props}>
      <Toolbar>
        <Hidden xlUp>
          <IconButton size="large" edge="start" onClick={onMenuClick}>
            <Menu />
          </IconButton>
        </Hidden>
        <Box display={{ xs: 'none', lg: 'block' }}>
          <Link to={logoTarget}>
            <Toolbar>
              <Logo />
            </Toolbar>
          </Link>
        </Box>
        <ButtonWrapper />
        <UserMenu />
        <LanguageSelect />
      </Toolbar>
    </StyledTopbar>
  )
}

export default Topbar
